var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bmui-cell_paragraph" }, [
    _c("p", { staticClass: "bmui-cell_paragraph-title" }, [
      _vm._v(_vm._s(_vm.title || "TITLE")),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNeed,
              expression: "isNeed"
            }
          ],
          staticClass: "bmui-cell_paragraph-isNeed"
        },
        [_vm._v("*")]
      )
    ]),
    _vm._v(" "),
    _vm.$slots.default
      ? _c(
          "div",
          { staticClass: "bmui-cell_paragraph-content" },
          [_vm._t("default")],
          2
        )
      : _c("p", { staticClass: "bmui-cell_paragraph-content" }, [
          _vm._v(_vm._s(_vm.content))
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e0b33b5", { render: render, staticRenderFns: staticRenderFns })
  }
}